module.exports = __webpack_public_path__ + "img/Path1.ec61779d.svg";